import { MutationTree } from 'vuex'

import { MatchedState } from '@/types/store'
import { IMatched } from '@/types/matched'

export const mutations: MutationTree<MatchedState> = {
  matchedsLoadStart(state) {
    state.isMatchedsLoading = true
  },
  matchedsLoaded(
    state,
    { items, total }: { items: IMatched[]; total?: number },
  ) {
    state.matcheds = items
    state.total = total === undefined ? state.total : total
    state.isMatchedsLoading = false
  },
  matchedUpdated(state, { id, matched }: { id: string; matched: IMatched }) {
    state.matcheds = state.matcheds.map(m => {
      if (m.id === id) {
        return matched
      }
      return m
    })
  },
  matchedUpdatedByName(
    state,
    { name, matched }: { name: string; matched: IMatched },
  ) {
    state.matcheds = state.matcheds.map(m => {
      if (m.name === name) {
        return {
          ...m,
          code: matched.code,
          matchedName: matched.matchedName,
          isToBeDeleted: matched.isToBeDeleted,
          isApproved: matched.isApproved,
        }
      }
      return m
    })
  },
  matchedDeleted(state, deletedId: string) {
    state.matcheds = [...state.matcheds.filter(m => m.id !== deletedId)]
  },
  matchedDeletedByName(state, deletedName: string) {
    state.matcheds = [...state.matcheds.filter(m => m.name !== deletedName)]
  },
}
